"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const app_platform_value_type_definitions_1 = require("@semios/app-platform-value-type-definitions");
const zod_1 = require("zod");
const boundaries = zod_1.z.object({
    northEast: zod_1.z.object({
        lng: zod_1.z.number(),
        lat: zod_1.z.number(),
    }),
    southWest: zod_1.z.object({
        lng: zod_1.z.number(),
        lat: zod_1.z.number(),
    }),
});
const blockRequestBy = zod_1.z.object({
    blockIds: zod_1.z.array(zod_1.z.number()).optional(),
    propertyIds: zod_1.z.array(zod_1.z.number()).optional(),
    boundaries: boundaries.optional(),
});
const propertiesRequestBy = zod_1.z.object({
    propertyIds: zod_1.z.array(zod_1.z.number()).optional(),
    boundaries: boundaries.optional(),
});
const pointsRequestBy = zod_1.z.object({
    lngLats: zod_1.z.array(zod_1.z.string()).optional(),
    propertyIds: zod_1.z.array(zod_1.z.number()).optional(),
    boundaries: boundaries.optional(),
});
const heatmapPointsRequestBy = zod_1.z.object({
    blockIds: zod_1.z.array(zod_1.z.number()).optional(),
    boundaries: boundaries.optional(),
});
const irrigationZonesRequestBy = zod_1.z.object({
    irrigationZoneIds: zod_1.z.array(zod_1.z.number()).optional(),
    propertyIds: zod_1.z.array(zod_1.z.number()).optional(),
    boundaries: boundaries.optional(),
});
const regionsRequestBy = zod_1.z.object({
    regionIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    boundaries: boundaries.optional(),
});
exports.requestSchema = zod_1.z
    .object({
    blocks: blockRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_Blocks, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            id: zod_1.z.boolean().optional(),
            labelLngLat: zod_1.z.boolean().optional(),
            name: zod_1.z.boolean().optional(),
            propertyId: zod_1.z.boolean().optional(),
            propertyName: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return (!args || Number(!!args?.blockIds) + Number(!!args?.boundaries) + Number(!!args?.propertyIds) === 1);
    }, { message: 'Must specify only one of blockIds xor boundaries xor propertyIds' }),
    points: pointsRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_Points, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            id: zod_1.z.boolean().optional(),
            lngLat: zod_1.z.boolean().optional(),
            name: zod_1.z.boolean().optional(),
            propertyId: zod_1.z.boolean().optional(),
            propertyName: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return (!args || Number(!!args?.lngLats) + Number(!!args?.boundaries) + Number(!!args?.propertyIds) === 1);
    }, { message: 'Must specify only one of lngLats xor boundaries xor propertyIds' }),
    heatmap_points: heatmapPointsRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_HeatmapPoints, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            id: zod_1.z.boolean().optional(),
            lngLat: zod_1.z.boolean().optional(),
            propertyId: zod_1.z.boolean().optional(),
            propertyName: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return !args || Number(!!args?.blockIds) + Number(!!args?.boundaries) === 1;
    }, { message: 'Must specify only one of blockIds xor boundaries xor propertyIds' }),
    properties: propertiesRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_Properties, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            id: zod_1.z.boolean().optional(),
            labelLngLat: zod_1.z.boolean().optional(),
            name: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return !args || Number(!!args?.propertyIds) + Number(!!args?.boundaries) === 1;
    }, { message: 'Must specify only one of propertyIds xor boundaries' }),
    irrigation_zones: irrigationZonesRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_IrrigationZoneEmitters, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            labelLngLat: zod_1.z.boolean().optional(),
            name: zod_1.z.boolean().optional(),
            propertyId: zod_1.z.boolean().optional(),
            propertyName: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
            id: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return (!args ||
            Number(!!args?.irrigationZoneIds) + Number(!!args?.boundaries) + Number(!!args?.propertyIds) === 1);
    }, { message: 'Must specify only one of irrigationZoneIds xor boundaries xor propertyIds' }),
    regions: regionsRequestBy
        .merge(zod_1.z.object({
        values: zod_1.z.record(app_platform_value_type_definitions_1.VC.ValuesCurrentEnums.ZEnumValuesCurrentValueTypes_Regions, zod_1.z.boolean()),
        _metaData: zod_1.z
            .object({
            _idsToSkipForMetaData: zod_1.z.array(zod_1.z.string()).optional(),
            id: zod_1.z.boolean().optional(),
            geometry: zod_1.z.boolean().optional(),
            name: zod_1.z.boolean().optional(),
            labelLngLat: zod_1.z.boolean().optional(),
            timezone: zod_1.z.boolean().optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).filter((arg) => arg !== '_idsToSkipForMetaData').length, {
            message: 'Must request at least one attribute from metadata if doing any at all',
        }),
    }))
        .optional()
        .refine((args) => {
        return !args || Number(!!args?.regionIds) + Number(!!args?.boundaries) === 1;
    }, { message: 'Must specify only one of regionIds xor boundaries' }),
})
    .refine((args) => !!Object.keys(args).length, { message: 'Must request at least one type of field asset' });
exports.path = '/values-current';
//# sourceMappingURL=index.js.map